import React from 'react';
import {Main, Feature, Demo, Price, Footer } from './components/landingpage';

function App() {
    return (
        <React.Fragment>
            <Main />
            <Feature />
            <Demo />
            <Price />
            <Footer />
        </React.Fragment>
    )
}

export default App;